export const CLIENT_TYPES = {
  FLOATING: "floating",
  AVATAR: "avatar",
};

export type ClientType = (typeof CLIENT_TYPES)[keyof typeof CLIENT_TYPES];

export type PlayClient = { type: ClientType; id?: number };
